import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'terms_and_conditions.title',
    defaultMessage: 'Terms and Conditions',
  },
  button: {
    id: 'terms_and_conditions.button',
    defaultMessage: 'I Understand',
  },
});
